<div class="input-group  mb-3">
  <div class="form-floating">
    <input class="form-control"
           placeholder="dd.mm.yyyy"
           name="{{ID}}"
           #c2="ngModel"
           [disabled]="!enabeld" [readonly]="!enabeld"
           [(ngModel)]="Date"
           (ngModelChange)="onChange($event)"
           [ngModelOptions]="{ updateOn: 'blur' }"
           (blur)="onChange(c2.value)"
           (keyup.enter)="$event.target.blur(); "
           ngbDatepicker
           #d="ngbDatepicker"
           dateMask  />
    <label for="{{ID}}">{{ LabelText }}</label>
  </div>
  <button class="input-group-text bi bi-calendar-check" (click)="setToday()" type="button"></button>
  <button class="input-group-text bi bi-calendar3" (click)="d.toggle()" type="button"></button>
</div>

